import React from "react";
import { useNavigate } from "react-router-dom";
import { PUBLIC_HUB } from "../../utils/appHub";

const LOGO_FULL_SRC = "/logo-full.png?v=8";
const LOGO_ICON_SRC = "/logo-icon.png?v=8";
const LOGO_HEIGHT_CLASS = "h-14";

const BrandLogo = ({
  className = "",
  logoClassName = "",
  showWordmark = true,
  iconOnly = false,
}) => {
  const navigate = useNavigate();
  const useIcon = iconOnly || !showWordmark;

  return (
    <button
      type="button"
      onClick={() => navigate(PUBLIC_HUB)}
      className={`inline-flex shrink-0 overflow-visible focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/40 focus-visible:ring-offset-2 rounded-lg transition-opacity hover:opacity-90 ${className}`}
      aria-label="Go to EmergencyQR website"
    >
      <img
        src={useIcon ? LOGO_ICON_SRC : LOGO_FULL_SRC}
        alt="EmergencyQR by Dityaverse Pvt. Ltd."
        className={`block object-contain object-center shrink-0 w-auto ${
          useIcon ? `${LOGO_HEIGHT_CLASS} aspect-square` : LOGO_HEIGHT_CLASS
        } ${logoClassName}`}
      />
    </button>
  );
};

export default BrandLogo;
